__turbopack_context__.v({
  "appear-slide-left": "ServiceBox-module-scss-module__WII_9a__appear-slide-left",
  "bounceTwice": "ServiceBox-module-scss-module__WII_9a__bounceTwice",
  "fade-in-bottom": "ServiceBox-module-scss-module__WII_9a__fade-in-bottom",
  "fade-in-left": "ServiceBox-module-scss-module__WII_9a__fade-in-left",
  "fade-in-right": "ServiceBox-module-scss-module__WII_9a__fade-in-right",
  "fadeIn": "ServiceBox-module-scss-module__WII_9a__fadeIn",
  "flexContainer": "ServiceBox-module-scss-module__WII_9a__flexContainer",
  "linkContainer": "ServiceBox-module-scss-module__WII_9a__linkContainer",
  "loader": "ServiceBox-module-scss-module__WII_9a__loader",
  "puff-in-center": "ServiceBox-module-scss-module__WII_9a__puff-in-center",
  "puff-in-left": "ServiceBox-module-scss-module__WII_9a__puff-in-left",
  "pulse": "ServiceBox-module-scss-module__WII_9a__pulse",
  "pulse-contact": "ServiceBox-module-scss-module__WII_9a__pulse-contact",
  "reverse": "ServiceBox-module-scss-module__WII_9a__reverse",
  "serviceBox": "ServiceBox-module-scss-module__WII_9a__serviceBox",
  "serviceImage": "ServiceBox-module-scss-module__WII_9a__serviceImage",
  "shake-bottom": "ServiceBox-module-scss-module__WII_9a__shake-bottom",
  "slide-again": "ServiceBox-module-scss-module__WII_9a__slide-again",
  "slide-in-right": "ServiceBox-module-scss-module__WII_9a__slide-in-right",
  "stepContent-entrance": "ServiceBox-module-scss-module__WII_9a__stepContent-entrance",
  "text": "ServiceBox-module-scss-module__WII_9a__text",
});
